module.exports = __webpack_public_path__ + "img/51.9.TU.f02ce539.png";